import { IDBPDatabase, openDB } from 'idb';

export class IDBService {
  private static _DB: IDBPDatabase<unknown> | undefined;
  private dbName: 'db-cache' | 'db-temp';
  private storeName:
    | 'store-home-watchface-images'
    | 'stroe-export-image-buffer';
  constructor(
    dbName: IDBService['dbName'],
    storeName: IDBService['storeName']
  ) {
    this.dbName = dbName;
    this.storeName = storeName;
  }
  private async getDB() {
    if (IDBService._DB) return IDBService._DB;
    const storeNames: IDBService['storeName'][] = [
      'store-home-watchface-images',
      'stroe-export-image-buffer'
    ];
    const _db = await openDB(this.dbName, 1, {
      upgrade(db) {
        // 保存snapshots
        storeNames.forEach((stroeName) => {
          db.createObjectStore(stroeName);
        });
      }
    });
    IDBService._DB = _db;
    return _db;
  }
  async getItem(key: string) {
    const db = await this.getDB();
    return await db.get(this.storeName, key);
  }
  async putItem(key: string, val: ArrayBuffer | string) {
    const db = await this.getDB();
    return await db.put(this.storeName, val, key);
  }
  async clear() {
    const db = await this.getDB();
    return await db.clear(this.storeName);
  }
  async deleteItem(key: string) {
    const db = await this.getDB();
    return await db.delete(this.storeName, key);
  }
  async getAllKeys() {
    const db = await this.getDB();
    return await db.getAllKeys(this.storeName);
  }
}
